import { Component, OnInit, NgZone } from '@angular/core';
import { WorkOrderService } from '../../services/work-order.service';
import { IWorkOrder } from '../../work-order/work-order-list/work-order-list.component';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { CreateBudgetModalComponent } from './createBudgetModal/createBudgetModal.component';
import { RejectBudgetModalComponent } from './../reject-budget-modal/reject-budget-modal.component';
import { NotifierService } from '../../shared/notifier/notifier.service';
import { AlertComponent } from '../../../shared';
import { NgForm } from '@angular/forms';
import { BudgetService } from '../../services/budget.service';
import * as fileSaver from 'file-saver';
import { ReportesService } from '../../services/reportes.service';
import { ListofvaluesService } from '../../services/listofvalues.service';
import { ProviderService } from '../../services/provider.service';
import { PDFService } from '../../services/pdf.service';
import { BillingService } from '../../services/billing.service';
import { IfStmt } from '@angular/compiler';
import { OcBudgetModalComponent } from './ocBudgetModal/ocBudgetModal.component';
import { UserService } from '../../services/usuario.service';
import { CreateGlobalDiscountComponent } from './create-global-discount/create-global-discount.component';

@Component({
  selector: 'app-new-budget',
  templateUrl: 'new-budget.component.html',
  styleUrls: ['new-budget.component.scss'],
  providers: [WorkOrderService, BudgetService, ListofvaluesService, ReportesService, ProviderService, PDFService, BillingService, UserService]
})
export class NewBudgetComponent implements OnInit {
  paramId = 0;
  budgetId = 0;
  budgetState = '';
  globalTypo :any;
  canEdit = false;
  esOwner = 0;
  workOrderData: IWorkOrder;
  budgetHeaderData: any;
  budgetDetailData: Array<IBudgetDetail>;
  tableSettingsBudgetDetail: any = undefined;
  dataSourceBudgetDetail: any = undefined;
  tableDataBudgetDetail: any = {};
  ldvMoney: any;
  permission = false;
  cuenta_approve = false;
  ldvDefaultComission: number;
  client_no_comission = false;
  listStatesBudget = [];
  listProviders: any = [];
  discounts: any = [];
  discountGlobal = 0;
  billList: any = [];
  budgetHeaderPrice: any; //With comission
  budgetHeaderTax: any;
  comAgencia: any;
  descuento: any;
  descuentoTotal : any ;
  priceWithoutComission: any;
  priceWithTax: any;
  tax_text = '';
  tax_percentage = '';
  tax_val: any;
  haveProvider: boolean = false;
  perPage = 10;
  valExport = false;
  orderGroup: {
    source: Array<any>,
    selectedIndex: number
  } = { source: [], selectedIndex: -1 };
  settings = {
    pager: { display: true, perPage: this.perPage },
    noDataMessage: 'No hay datos que mostrar.', columns: undefined,
    actions: {
      add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
      custom: [
        { name: 'editar', title: `<div class="editCustomButton">Editar</div>` },
        { name: 'eliminar', title: `<div class="editCustomButton">Eliminar</div>` }
      ]
    }
  };

  typeBilling: any = "";
  typeDebitNote: any = "";
  typeCreditNote: any = "";
  billNote:any = "";
  FullInvoiced = true;

  rolParaValidar = Number(localStorage.getItem('rolIdUser'));

  constructor(private reporteService: ReportesService,
    private workOrderService: WorkOrderService,
    private route: ActivatedRoute,
    private listofvaluesService: ListofvaluesService,
    public dialog: MatDialog,
    private notifierService: NotifierService,
    private zone: NgZone,
    private budgetService: BudgetService,
    private providerService: ProviderService,
    private pdfService: PDFService,
    private routes: Router,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private billingService: BillingService) {

    this.userService.obtenerDatosPersonales().subscribe( (personal: any) => {
      this.rolParaValidar = personal.rol;
    })

    this.listofvaluesService.getLdvByCode('TBWA-MONEY').subscribe((result) => {
      this.ldvMoney = result;
    });
    this.activatedRoute.params.subscribe(params => {
      const data = params['jwt'];
      if (data) {
        localStorage.setItem('jwt', data);
      }
    });
    this.budgetHeaderData = {};
    this.budgetDetailData = [];
    this.providerService.listProviders().subscribe((result) => {
      this.listProviders = result;
    });
    this.tableDataBudgetDetail = {
      columns: {
        arr_description: { title: 'Descripcion' },
        provider_name: { title: 'Proveedor' },
        cost_provider_string: { title: 'Costo de Proveedor' },
        type_description: { title: 'Tipo' },
        quantity: { title: 'Cantidad' },
        unit_price_string: { title: 'Precio Unitario' },
        price_string: { title: 'Precio' },
        commission_value: { title: 'Comision' },
        client_comision_val: { title: 'Porcentaje Comision' },
      },
      data: {}
    };
    this.route.params.subscribe((params) => {
      this.listofvaluesService.getLdvByCode('TBWA-PARAMETER').subscribe((result: any) => {
        result.forEach(element => {
          // tslint:disable-next-line:triple-equals
          if (element.value == 'Comisión Cliente Estándar') {
            this.ldvDefaultComission = element.ref1;
          }
        });
      });
      if (params['id']) {

        this.budgetId = params['id'];

        this.billingService.getBillByBudget(this.budgetId).subscribe((result) => {
          this.billList=result;
          let aux=[]
          this.billList.forEach(element => {
            if(element.note_reason == null){
              aux.push(element)
            }
          });
          this.billList=aux;
        })


        this.budgetService.getOneBudget(this.budgetId).subscribe((result) => {
          this.budgetHeaderData = result;
          this.esOwner = this.budgetHeaderData.esowner;
          // tslint:disable-next-line:triple-equals
          if (this.budgetHeaderData.client_comision == undefined || this.budgetHeaderData.client_comision == null) {
            this.client_no_comission = true;
          }
          if(this.budgetHeaderData.client_doc_type == 'EXPORTACION'){
            this.valExport = true;
          }
          
          this.listofvaluesService.getLdvByCode('TBWA-STATE-BUDGET').subscribe((listStatesBudget: any) => {
            this.listStatesBudget = listStatesBudget;
            const found = this.listStatesBudget.find((item) => {
              // tslint:disable-next-line:triple-equals
              return item.ref1 == this.budgetHeaderData.state;
            });
            this.budgetState = found.value;
          });
          // tslint:disable-next-line:triple-equals
          if (this.budgetHeaderData.state == 1 || this.budgetHeaderData.state == 5) {
            this.canEdit = true;
          } else {
            this.canEdit = false;
          }

          /*if(this.budgetHeaderData.state == 8){
            this.budgetService.getPermissionCuenta(this.budgetHeaderData.client_code).subscribe((resultCuenta:any) => {
              //this.cuenta_approve = resultCuenta;
              console.log("res",resultCuenta);
            });
          }*/
          // Obtiene los permisos de vistas (botones, editar, acciones)
          this.getPermissionVista().then(() => {
            if (!this.canEdit) {
              this.settings = {
                pager: { display: true, perPage: this.perPage },
                noDataMessage: 'No hay datos que mostrar.', columns: undefined,
                actions: {
                  add: false, delete: false, position: 'right', edit: false, columnTitle: '',
                  custom: []
                }
              };
            }
            // tslint:disable-next-line:triple-equals
            this.budgetService.getBudgetDetails(this.budgetId).subscribe((budgetDetails: Array<IBudgetDetail>) => {
              this.budgetDetailData = budgetDetails;
              this.budgetDetailData.forEach((item) => {
                item.action_backend = 'E';
                if(item.invoiced==0){
                  this.FullInvoiced=false;
                }
              });
              this.paramId = params['otid'];
              this.budgetHeaderData.work_order_id = this.paramId;
              this.workOrderService.getWorkOrder(params['otid']).subscribe((workOrder: IWorkOrder) => {
                this.workOrderData = workOrder;
              });
              this.getTableData(this.budgetDetailData);
            });
            

          });
        });
      } else {

        this.userService.obtenerDatosPersonales().subscribe( (personal: any) => {
          this.rolParaValidar = personal.rol;

          if (this.rolParaValidar == 1) {
            this.routes.navigate(['/system/work-order/list']);
          } else {

            if (params['otid']) {
              this.paramId = params['otid'];
              this.budgetHeaderData.work_order_id = this.paramId;
              this.budgetHeaderData.tax = 1;
              this.budgetHeaderData.currency = 7;
              this.canEdit = true;
              this.listofvaluesService.getLdvByCode('TBWA-LEGALTEXT-BUDGET').subscribe((textResult: any) => {
                this.budgetHeaderData.legal_text = textResult[0].value;
                this.workOrderService.getWorkOrder(params['otid']).subscribe((workOrder: IWorkOrder) => {
                  this.budgetHeaderData.client_comision = workOrder.client_comision;
                  if(workOrder.client_doc_type == 'EXPORTACION'){
                    this.budgetHeaderData.tax = 2;
                    this.valExport = true;
                  }
                  // tslint:disable-next-line:triple-equals
                  if (this.budgetHeaderData.client_comision == undefined || this.budgetHeaderData.client_comision == null) {
                    this.client_no_comission = true;
                  }
                  this.workOrderData = workOrder;
                  this.getTableData([]);
                });
              });
            }



          }

        })
    

        

        
      }
    });
  }

  goBilling(){
    if(this.typeBilling == "ND" && this.typeDebitNote!="" && this.billNote!=""){
      this.routes.navigate(["/system/billing/new/"+ this.budgetHeaderData.id, {type: this.typeBilling + "-" + this.typeDebitNote, bill:this.billNote}])
    }
    if(this.typeBilling == "NC" && this.typeCreditNote!="" && this.billNote!=""){
      this.routes.navigate(["/system/billing/new/"+ this.budgetHeaderData.id, {type: this.typeBilling + "-" + this.typeCreditNote, bill:this.billNote}])
    }
    if(this.typeBilling == "B" || this.typeBilling == "F" || this.typeBilling == "GR"){
      this.routes.navigate(["/system/billing/new/"+ this.budgetHeaderData.id, {type: this.typeBilling}])
    }
  }

  onChangeBillSelection(){
    this.typeCreditNote = "";
    this.typeDebitNote = "";
  }

  updateVals(){
    this.getTableData(this.budgetDetailData);
  }

  private async getPermissionVista() {
    if (this.budgetHeaderData.solicitud_id) {
      // tslint:disable-next-line:triple-equals
      if (this.budgetHeaderData.state == 2 || this.budgetHeaderData.state == 3) {
        const cod: any = await this.getPermissionNormal(this.budgetHeaderData.solicitud_id);
        // tslint:disable-next-line:triple-equals
        if (cod.codigo != null && cod.codigo != undefined) {
          this.permission = true;
          // tslint:disable-next-line:triple-equals
          if (this.budgetHeaderData.state == 2) {
            this.canEdit = true;
          }
        }

        // tslint:disable-next-line:triple-equals
      } else if (this.budgetHeaderData.state == 8) {
        const code: any = await this.getPermissionCuenta(this.budgetHeaderData.solicitud_id, this.budgetHeaderData.client_code);
        // tslint:disable-next-line:triple-equals
        if (code.codigo != null && code.codigo != undefined) {
          this.permission = true;

        }
      }
    }
    return;
  }

  private async getPermissionNormal(id) {
    try {
      return await this.budgetService.getPermission(id).toPromise();
    } catch (e) {
      throw e;
    }
  }

  private async getPermissionCuenta(id, code) {
    try {
      return await this.budgetService.getPermissionCuenta(id, code).toPromise();
    } catch (e) {
      throw e;
    }
  }
  retornar(){

    this.budgetService.retornarEstado(this.budgetId).subscribe((result: any[]) => {
      this.notifierService.systemNotify({
        title: 'Exito',
        message: 'Recargue la página.',
        type: 'success'
      });
    })
  }
  getTableData(result) {

    this.budgetService.getDiscountDetails(this.budgetId).subscribe((result: any[]) => {
      this.discounts = result;
    })


    this.budgetHeaderPrice = 0;
    this.budgetHeaderTax = 0;
    this.comAgencia = 0;
    this.descuento = 0;
    const cloneRows: Array<any> = [...result];
    console.log('cloneRows: ', cloneRows);
    for (const item of cloneRows) {

      if (item.cost_provider) {
        item.cost_provider_string = Number(item.cost_provider).toFixed(2);
        item.cost_provider_string = this.budgetService.transformNumber(item.cost_provider_string);
        this.haveProvider = true;
        //item.cost_provider = item.cost_provider.toFixed(2);
      }
      item.aperture_date = moment(item.aperture_date).format('DD/MM/YYYY');
      //item.closed = item.closed === 1 ? 'Cerrado' : 'Abierto';
      if (item.with_commission) {
        item.commission_value = 'SI';
      } else {
        item.commission_value = 'NO';
      }

      if (item.type) {
        switch (Number(item.type)) {
          case 1:
            item.type_description = 'Fee Agencia';
            break;
          case 2:
              item.type_description = 'Creatividad Agencia';
              break;
          case 3:
              item.type_description = 'Supervisión Producción';
              break;
          case 4:
              item.type_description = 'Home Edición';
              break;
          case 5:
              item.type_description = 'Home Producción';
              break;
          case 6:
              item.type_description = 'Comisión de Agencia';
              break;
          case 7:
              item.type_description = 'Proveedores';
              break;
          case 8:
              item.type_description = 'ZIEL';
              break;
          case 9:
              item.type_description = 'BANG';
              break;              
          default:
            item.type_description = ''
            break;
        }
      } else {
        item.type_description = ''
      }

      if (item.with_commission) {
        if (!this.client_no_comission) {
          item.client_comision = this.budgetHeaderData.client_comision;
        } else {
          item.client_comision = this.ldvDefaultComission;
        }
      } else {
        item.client_comision = 0;
      }
      item.price_clean = item.price
      if (item.discount_type == 2){
        item.price_clean -= (item.discount_amount);
        this.descuento += (item.discount_amount)
        
      }else if (item.discount_type == 3){
        item.price_clean -= Number(((item.discount_amount)/100)*  item.price_total);

        this.descuento += Number(((item.discount_amount)/100)*  item.price_total).toFixed(2);
      }

      item.price_total = Number(item.price_clean) + Number(item.price_clean * item.client_comision);
      // item.price_total = item.price_total.toFixed(2);
      item.client_comision_val = (item.client_comision * 100).toFixed(2) + '%';
      this.budgetHeaderPrice += item.price_total;
      //console.log(item.price_total * 0.18)
      this.budgetHeaderTax += Number((item.price_total * 0.18).toFixed(2));
      this.comAgencia += (item.price_total - item.price_clean);
     
      
      item.quantity=item.quantity?item.quantity : 1;
      item.unit_price = item.unit_price ? item.unit_price:item.price_clean;

      item.unit_price_string = Number(item.unit_price).toFixed(2);
      item.unit_price_string = this.budgetService.transformNumber(item.unit_price_string);
      
      item.price_string = Number(item.price_clean).toFixed(2);
      item.price_string = this.budgetService.transformNumber(item.price_string);
      console.log(item)
      item.price_string_origin = Number(item.price).toFixed(2);
      item.arr_description = item.description.split("\n");

    }

    this.priceWithoutComission = Number(this.budgetHeaderPrice - this.comAgencia + this.descuento).toFixed(2);
    
    if (this.globalTypo == 1 ){
      this.budgetHeaderData.discount_global = this.budgetHeaderData.discount_global * (this.priceWithoutComission -  this.descuento)/100;
      console.log('  this.budgetHeaderData.discount_global ',  this.budgetHeaderData.discount_global )
    }else  if (this.globalTypo == 2 ){

      console.log('  this.budgetHeaderData.discount_global ',  this.budgetHeaderData.discount_global )
    }
    this.budgetHeaderData.discount_global = this.budgetHeaderData.discount_global?this.budgetHeaderData.discount_global:0;
    this.budgetHeaderTax -= Number(this.budgetHeaderData.discount_global * 0.18)
    //this.comAgencia -=  this.budgetHeaderData.discount_global*0.08;
    this.budgetHeaderPrice  -=  this.budgetHeaderData.discount_global?this.budgetHeaderData.discount_global:0;
    console.log('DEC', this.descuento ,  this.budgetHeaderData.discount_global)
    this.descuentoTotal = this.descuento +  this.budgetHeaderData.discount_global ;
    console.log('descuentoTotal', this.descuentoTotal)

    this.priceWithoutComission = this.budgetService.transformNumber(this.priceWithoutComission);


    switch (Number(this.budgetHeaderData.tax)) {
      case 1:
        this.tax_text = 'IGV';
        this.priceWithTax = this.budgetHeaderPrice + this.budgetHeaderTax;
        //console.log(this.priceWithTax);
        this.tax_val = this.budgetHeaderTax;
        //console.log(this.tax_val); 
        this.tax_percentage = '18%';
        break;
      case 2:
      this.tax_text = 'Inafecto';
      this.priceWithTax = this.budgetHeaderPrice;
      this.tax_val = 0;
      this.tax_percentage = '0%';
        break;
      case 3:
      this.tax_text = 'Exonerado';
      this.priceWithTax = this.budgetHeaderPrice;
      this.tax_val = 0;
      this.tax_percentage = '0%';
        break;
        case 16:
      this.tax_text = 'Exportación';
      this.priceWithTax = this.budgetHeaderPrice;
      this.tax_val = 0;
      this.tax_percentage = '0%';
        break;
      default:
        break;
    }
    this.descuentoTotal = Number(this.descuentoTotal).toFixed(2);
    this.descuentoTotal = this.budgetService.transformNumber(this.descuentoTotal);
    console.log('descuentoTotalFIN', this.descuentoTotal)
    this.budgetHeaderPrice = Number(this.budgetHeaderPrice).toFixed(2);
    this.budgetHeaderPrice = this.budgetService.transformNumber(this.budgetHeaderPrice);
    this.priceWithTax = Number(this.priceWithTax).toFixed(2);
    this.priceWithTax = this.budgetService.transformNumber(this.priceWithTax);
    this.tax_val = Number(this.tax_val).toFixed(2);
    this.tax_val = this.budgetService.transformNumber(this.tax_val);
    this.comAgencia = Number(this.comAgencia).toFixed(2);
    this.comAgencia = this.budgetService.transformNumber(this.comAgencia);
    
    this.dataSourceBudgetDetail = new LocalDataSource(cloneRows);
    this.tableSettingsBudgetDetail = this.copyObject(this.settings);
    if (this.tableDataBudgetDetail.columns !== undefined) {
      this.tableSettingsBudgetDetail.columns = this.copyObject(this.tableDataBudgetDetail.columns);

      this.tableSettingsBudgetDetail.columns['arr_description'] = {
        'title': this.tableSettingsBudgetDetail.columns['arr_description'].title, type: 'html', valuePrepareFunction: function (value) {
          let line = ''
          let idxLast =0
          for (let i = 0; i < value.length-1; i++) {
            const element = value[i];
            line = line +'<span>'+element+'<span><br>'
            idxLast = i+1
          }
          line = line +'<span>'+value[idxLast]+'<span>'
          return '<div> ' + line + ' </div>';
        }
      };

      this.tableSettingsBudgetDetail.columns['client_comision_val'] = {
        'title': this.tableSettingsBudgetDetail.columns['client_comision_val'].title, type: 'html', valuePrepareFunction: function (value) {
          return '<div class="numberformat" > ' + value + ' </div>';
        }
      };

      this.tableSettingsBudgetDetail.columns['quantity'] = {
        'title': this.tableSettingsBudgetDetail.columns['quantity'].title, type: 'html', valuePrepareFunction: function (value) {
          return '<div class="numberformat" > ' + value + ' </div>';
        }
      };

      this.tableSettingsBudgetDetail.columns['unit_price_string'] = {
        'title': this.tableSettingsBudgetDetail.columns['unit_price_string'].title, type: 'html', valuePrepareFunction: function (value) {
          return '<div class="numberformat " > ' + value + ' </div>';
        }
      };


      this.tableSettingsBudgetDetail.columns['price_string'] = {
        'title': this.tableSettingsBudgetDetail.columns['price_string'].title, type: 'html', valuePrepareFunction: function (value,row) {
          if (row.price_string_origin != value){
            return '<div class="numberformat "> ' + value + ' </div><div class="numberformat "><del>' + row.price_string_origin + '</del></div>';
          }else{
            return '<div class="numberformat "> ' + value + ' </div>';
          }
          
        }
      };

      this.tableSettingsBudgetDetail.columns['cost_provider_string'] = {
        'title': this.tableSettingsBudgetDetail.columns['cost_provider_string'].title, type: 'html', valuePrepareFunction: function (value) {
          if (value) {
            return '<div class="numberformat" > ' + value + ' </div>';
          }
        }
      };

      // Se deshabilita los filtros predefinidos para evitar conflictos
      Object.keys(this.tableSettingsBudgetDetail.columns).forEach(key => {
        this.tableSettingsBudgetDetail.columns[key].filter = true;
      });
    }
  }

  ngOnInit() {
    this.getTableData([]);
  }

  /*async updateState() {
    const budget_header: any = await this.getBudgetOneBudgetHeader(this.budgetId);

    this.budgetHeaderData.solicitud_id = budget_header.solicitud_id;
    this.budgetService.getOneBudget(this.budgetId).subscribe((result: any) => {
      this.budgetHeaderData.solicitud_id = result.solicitud_id;
    });
    const found = this.listStatesBudget.find((item) => {
      // tslint:disable-next-line:triple-equals
      return item.ref1 == this.budgetHeaderData.state;
    });
    this.budgetState = found.value;
}*/

  /*private async getBudgetOneBudgetHeader(id) {
    try {
      return await this.budgetService.getOneBudget(id).toPromise();
    } catch (e) {
      throw e;
    }
  }*/

  exportPDF() {
    this.notifierService.systemNotify({
      title: 'Espere un momento',
      message: 'Descargando PDF',
      type: 'info',
      duration: 20000
    });
    const tempCurrency = this.ldvMoney.find(
      x => {
        // tslint:disable-next-line:triple-equals
        return x['id'] == this.budgetHeaderData.currency ? true : false;
      });
    this.budgetHeaderData['currency_name'] = tempCurrency ? tempCurrency['ref1'] : '';
    var actualDate = new Date().toLocaleString().split(" ")[0];
    var budgetNumber = this.budgetHeaderData.external_code.split("/")[1] + "/" + this.budgetHeaderData.external_code.split("/")[2];

    var listtext = false;
    if(this.budgetHeaderData.legal_text.includes("-")){
      var textLegal = this.budgetHeaderData.legal_text.split("-");
      textLegal.shift();
      listtext=true;
    } else {
      var textLegal = this.budgetHeaderData.legal_text;
    }

    var listNotes= false
    var p_note='';
    if(this.budgetHeaderData.pay_notes){
      p_note =this.budgetHeaderData.pay_notes.split("\n").filter(function (el) {return el != '' && el != ' ';});
      
      listNotes= true
    }

    this.listofvaluesService.getLdvByCode('TBWA-INFORMATION').subscribe((resInfo) => {
      const tempData = {
        budgetDetail: this.budgetDetailData,
        budgetHeader: this.budgetHeaderData,
        workOrder: this.workOrderData,
        date: actualDate,
        budgetNum: budgetNumber,
        totalPrice: this.budgetHeaderPrice,
        taxVal: this.tax_val,
        whitTaxPrice: this.priceWithTax,
        taxText: this.tax_text,
        legal: textLegal,
        taxPercentage: this.tax_percentage,
        group: resInfo[0],
        ruc: resInfo[1],
        address: resInfo[2],
        subtotal: this.priceWithoutComission,
        descuento: this.descuentoTotal , 
        comAgencia: this.comAgencia,
        userCreate: this.budgetHeaderData.user_name,
        listtext: listtext,
        pay_notes: p_note,
        listnotes: listNotes,
        tempDate: this.budgetHeaderData.created_date
      };

      this.pdfService.getPDF(tempData, 'budgetPDF').subscribe(
        (result: any) => {
          const filename = 'Presupuesto'+ this.budgetHeaderData.external_code +'.pdf';
          fileSaver.saveAs(result, filename);
          this.notifierService.systemNotify({
            title: 'Exito',
            message: 'Se ha descargado el PDF.',
            type: 'success'
          });
        },
        error => {
          console.log(error);
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Ha ocurrido un error al descarfar el PDF',
            type: 'error',
            duration: 5000
          });
        });
    })
  }
  exportExcel(fieldSearch) {
    let headerData;
    let copyData;

    headerData = [
      { dataBound: 'description', name: 'Descripcion', width: 40 },
      { dataBound: 'provider_name', name: 'Proveedor', width: 20 },
      { dataBound: 'cost_provider', name: 'Costo de Proveedor', width: 30 },
      { dataBound: 'money', name: 'Moneda', width: 30 },
      { dataBound: 'price', name: 'Precio', width: 30 },
      { dataBound: 'commission_value', name: 'Comision', width: 30 },
      { dataBound: 'client_comision_val', name: 'Porcentaje comision', width: 20 }];
    const data = this.dataSourceBudgetDetail.filteredAndSorted;
    copyData = this.dataSourceBudgetDetail.filteredAndSorted;
    const nameProyect = 'Reporte hora por cliente';



    const options = {
      fieldSeparator: ';',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      useBom: true,
      headers: ['Descripcion', 'Proveedor', 'Costo de Proveedor', 'Moneda', 'Precio', 'Comision', 'Porcentaje comision']
    };
    this.reporteService.exportExcel(headerData, copyData).subscribe(result => {
      const mediaType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const blob = new Blob([result._body], { type: mediaType });
      const fileName = 'Reporte';
      fileSaver.saveAs(blob, fileName);
    });

  }




  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }

  openCreateOC(){
    let budgetDetailsWithProvider = this.budgetDetailData.filter(detail => detail.provider_id);
    this.notifierService.behaviorNotify({
      object: { data: budgetDetailsWithProvider }
    });
    const deleteDialog = this.dialog.open(OcBudgetModalComponent,{
      width:`70%`,
      panelClass: 'ocModal'
    });
  }

  openCreateObject() {
    this.notifierService.behaviorNotify({
      action: 'register',
      model: 'budget',
      object: { data: {}, client_no_comission: this.client_no_comission, client_id: this.workOrderData.client_id }
    });
    const deleteDialog = this.dialog.open(CreateBudgetModalComponent);
    deleteDialog.afterClosed().subscribe((result: IBudgetDetail) => {
      if (result.action_backend === 'C') {
        let found = this.budgetDetailData.find((item) => {
          return (item.create_uuid === result.create_uuid);
        });
        if (found) {
          found = result;
        } else {
          this.budgetDetailData.push(result);
        }
      } else if (result.action_backend === 'U') {
        let found = this.budgetDetailData.find((item) => {
          return (item.id === result.id);
        });
        if (found) {
          found = result;
        }
      }
      this.getTableData(this.budgetDetailData);
    });
  }

  customAction(event) {

    switch (event.action) {
      case 'editar':
        this.notifierService.behaviorNotify({
          action: 'edit',
          model: 'budget',
          object: { data: event.data, client_no_comission: this.client_no_comission, client_id: this.workOrderData.client_id }
        });
        const dialogRef = this.dialog.open(CreateBudgetModalComponent);
        dialogRef.afterClosed().subscribe((result) => {
          console.log('event', event);
          if (result) {
            if (event.data.action_backend === 'C') {
              const index = this.budgetDetailData.findIndex((item) => {
                return item.create_uuid === event.data.create_uuid;
              });
              if (index) {
                this.budgetDetailData.splice(index, 1, event.data);
              }
            } else {
              event.data.action_backend = 'U';
            }
          }
          this.zone.run(() => {
            this.getTableData(this.budgetDetailData);
          });
        }, (error) => {
          console.log('error', error);
        });
        break;
      case 'eliminar':
        const deleteDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: 'exclamation-circle',
            iconColor: 'failure',
            title: 'Aviso',
            text: '¿Está seguro que desea eliminar el Cliente?',
            options: true
          }
        });
        deleteDialog.afterClosed().subscribe((result) => {
          if (result) {
            if (event.data.action_backend === 'C') {
              const index = this.budgetDetailData.findIndex((item) => {
                return item.create_uuid === event.data.create_uuid;
              });
              console.log(index);
              if (index !== undefined) {

                this.budgetDetailData.splice(index, 1);
              }
            } else {
              event.data.action_backend = 'D';
              console.log(event);
              const idToDelete = this.budgetDetailData.findIndex((toDelete) => {
                // tslint:disable-next-line:triple-equals
                return toDelete.id == event.data.id;
              });
              this.budgetDetailData.splice(idToDelete, 1);
            }
          }

          this.zone.run(() => {
            this.getTableData(this.budgetDetailData);
          });
        }, (error) => {
          console.log('error', error);
        });
        break;
    }


  }

  createBudget(form: NgForm) {

    if (this.rolParaValidar == 1) {
      return;
    }

    if (form.valid) {

      this.budgetService.InsertBudgetHeader(this.budgetHeaderData).subscribe((result: IBudgetHeader) => {
        this.budgetDetailData.forEach((item) => {
          item.id_budget_header = result.id;
        });
        this.budgetDetailData.forEach(element => {
          element.currency = this.budgetHeaderData.currency;
        });
        this.budgetService.InsertBudgetBatch(this.budgetDetailData).subscribe((listBudgetDetailResult) => {
          this.routes.navigate(['system/budget/edit/' + this.budgetHeaderData.work_order_id + '/' + result.id]);
          this.notifierService.systemNotify({
            title: 'Éxito',
            message: 'Se ha creado el presupuesto',
            type: 'success'
          });
        }, (error) => {
          this.notifierService.systemNotify({
            title: 'Ha ocurrido un error',
            message: 'Por favor póngase en contacto con el administrador',
            type: 'error'
          });
        });
      });
    } else {
      this.notifierService.systemNotify({
        title: 'Ha ocurrido un error',
        message: 'Por favor llene los campos obligatorios',
        type: 'error'
      });
    }
  }

  reloadComponent() {
    this.routes.routeReuseStrategy.shouldReuseRoute = () => false;
    this.routes.onSameUrlNavigation = 'reload';
    this.routes.navigate(['system/budget/edit/' + this.budgetHeaderData.work_order_id + '/' + this.budgetHeaderData.id]);
  }

  updateBudget(form: NgForm) {

    if (this.rolParaValidar == 1) {
      return;
    }

    this.budgetHeaderData.currency = Number(this.budgetHeaderData.currency);
    if (form.valid) {
      this.budgetService.updateBudget(this.budgetHeaderData).subscribe((updatedBudgetHeader) => {
        this.budgetDetailData.forEach((item) => {
          item.id_budget_header = this.budgetId;
          item.currency = this.budgetHeaderData.currency;
        });
        if(this.budgetDetailData.length > 0){
          this.budgetService.InsertBudgeAll(this.budgetDetailData, this.budgetId).subscribe((listBudgetDetailResult) => {
            this.notifierService.systemNotify({
              title: 'Éxito',
              message: 'Se ha actualizado el presupuesto',
              type: 'success'
            });
            this.routes.navigate(['system/budget/list']);
          }, (error) => {
            this.notifierService.systemNotify({
              title: 'Ha ocurrido un error',
              message: 'Por favor póngase en contacto con el administrador',
              type: 'error'
            });
          });
        } else {
          this.notifierService.systemNotify({
            title: 'Éxito',
            message: 'Se ha actualizado el presupuesto',
            type: 'success'
          });
          this.routes.navigate(['system/budget/list']);
        }
        /*this.budgetService.InsertBudgetBatch(this.budgetDetailData).subscribe((listBudgetDetailResult) => {
          this.notifierService.systemNotify({
            title: 'Éxito',
            message: 'Se ha actualizado el presupuesto',
            type: 'success'
          });
          this.routes.navigate(['system/budget/list']);
        }, (error) => {
          this.notifierService.systemNotify({
            title: 'Ha ocurrido un error',
            message: 'Por favor póngase en contacto con el administrador',
            type: 'error'
          });
        });*/
      });
    }
  }

  solAprov() {
    this.budgetService.solAprobation(this.budgetHeaderData).subscribe((result) => {
      this.notifierService.systemNotify({
        title: 'Éxito',
        message: 'Se ha solicitado la aprobación',
        type: 'success'
      });
      this.reloadComponent();
      // console.log(result);
      // this.budgetHeaderData.state = 2;
      // this.budgetHeaderData.solicitud_id = result[1];
      // this.updateState();
      /*this.zone.run(() => {
        this.settings = {
          pager: { display: true, perPage: this.perPage },
          noDataMessage: 'No hay datos que mostrar.', columns: undefined,
          actions: {
            add: false, delete: false, position: 'right', edit: false, columnTitle: '',
            custom: []
          }
        };
        this.getTableData(this.budgetDetailData);
        this.routes.navigate(['/system/budget/list']);
      });*/
    }, (error) => {
      this.notifierService.systemNotify({
        title: 'Ha ocurrido un error',
        message: 'Por favor póngase en contacto con el administrador',
        type: 'error'
      });
      // this.routes.navigate(['/system/budget/list']);
    });
  }
  Aprov() {
    // tslint:disable-next-line:triple-equals
    if (this.budgetHeaderData.state == 2) {// Registrar Aprobado Interno
      this.budgetHeaderData.aprobar = 1;
      this.budgetService.approveBudget({budget: this.budgetHeaderData, fee: this.workOrderData.fee}).subscribe((result) => {
        // this.budgetHeaderData.state = 3;
        // this.updateState();
        this.notifierService.systemNotify({
          title: 'Éxito',
          message: 'Se ha aprobado el presupuesto',
          type: 'success'
        });
        this.reloadComponent();
        //this.routes.navigate(['/system/budget/list']);
      }, (error) => {
        this.notifierService.systemNotify({
          title: 'Ha ocurrido un error',
          message: 'Por favor póngase en contacto con el administrador',
          type: 'error'
        });
        // this.routes.navigate(['/system/budget/list']);
      });
    }

    // tslint:disable-next-line:triple-equals
    if (this.budgetHeaderData.state == 3) {// Registrar Aprobado Cli
      this.budgetHeaderData.aprobar = 1;
      this.budgetService.approveBudgetClient(this.budgetHeaderData).subscribe((result) => {
        // this.budgetHeaderData.state = 4;
        // this.updateState();
        this.notifierService.systemNotify({
          title: 'Éxito',
          message: 'Se ha aprobado el presupuesto por el cliente',
          type: 'success'
        });
        this.routes.navigate(['/system/budget/list']);
      }, (error) => {
        this.notifierService.systemNotify({
          title: 'Ha ocurrido un error',
          message: 'Por favor póngase en contacto con el administrador',
          type: 'error'
        });
        // this.routes.navigate(['/system/budget/list']);
      });
    }

    // tslint:disable-next-line:triple-equals
    if (this.budgetHeaderData.state == 8) {// Registrar Aprobado Cuenta
      this.budgetHeaderData.aprobar = 1;
      this.budgetService.approveBudgetCuenta(this.budgetHeaderData).subscribe((result) => {
        this.notifierService.systemNotify({
          title: 'Éxito',
          message: 'Se ha aprobado el presupuesto',
          type: 'success'
        });
        this.routes.navigate(['/system/budget/list']);
      }, (error) => {
        this.notifierService.systemNotify({
          title: 'Ha ocurrido un error',
          message: 'Por favor póngase en contacto con el administrador',
          type: 'error'
        });
        // this.routes.navigate(['/system/budget/list']);
      });
    }
    // else{
    //   this.notifierService.systemNotify({
    //     title: 'Ha ocurrido un error',
    //     message: 'Por favor póngase en contacto con el administrador',
    //     type: 'error'
    //   });
    // }
  }
  Reject() {
    const rejectDialog = this.dialog.open(RejectBudgetModalComponent);
    rejectDialog.afterClosed().subscribe((result) => {
      if (result.reject) {
        // tslint:disable-next-line:triple-equals
        if (this.budgetHeaderData.state == 2) {// Registrar Aprobado Interno
          this.budgetHeaderData.aprobar = 0;
          this.budgetHeaderData.razon_rechazo = result.razon_rechazo;
          this.budgetService.approveBudget({budget: this.budgetHeaderData, fee: this.workOrderData.fee}).subscribe((approveBudgetResult) => {
            // this.budgetHeaderData.state = 1;
            // this.updateState();
            this.notifierService.systemNotify({
              title: 'Éxito',
              message: 'Se ha rechazado el presupuesto',
              type: 'success'
            });
            this.routes.navigate(['/system/budget/list']);
          }, (error) => {
            this.notifierService.systemNotify({
              title: 'Ha ocurrido un error',
              message: 'Por favor póngase en contacto con el administrador',
              type: 'error'
            });
            // this.routes.navigate(['/system/budget/list']);
          });
        }
        // tslint:disable-next-line:triple-equals
        if (this.budgetHeaderData.state == 3) {// Registrar Aprobado Interno
          this.budgetHeaderData.aprobar = 0;
          this.budgetHeaderData.razon_rechazo = result.razon_rechazo;
          // console.log("bud",this.budgetHeaderData);
          this.budgetService.approveBudgetClient(this.budgetHeaderData).subscribe((approveBudgetResult) => {
            // this.budgetHeaderData.state = 5;
            // this.updateState();
            this.notifierService.systemNotify({
              title: 'Éxito',
              message: 'Se ha rechazado el presupuesto',
              type: 'success'
            });
            this.routes.navigate(['/system/budget/list']);
          }, (error) => {
            this.notifierService.systemNotify({
              title: 'Ha ocurrido un error',
              message: 'Por favor póngase en contacto con el administrador',
              type: 'error'
            });
            // this.routes.navigate(['/system/budget/list']);
          });
        }
        // tslint:disable-next-line:triple-equals
        if (this.budgetHeaderData.state == 8) {// Registrar Aprobado Interno
          this.budgetHeaderData.aprobar = 0;
          this.budgetHeaderData.razon_rechazo = result.razon_rechazo;
          this.budgetService.approveBudgetCuenta(this.budgetHeaderData).subscribe((approveBudgetResult) => {
            // this.budgetHeaderData.state = 1;
            // this.updateState();
            this.notifierService.systemNotify({
              title: 'Éxito',
              message: 'Se ha rechazado el presupuesto',
              type: 'success'
            });
            this.routes.navigate(['/system/budget/list']);
          }, (error) => {
            this.notifierService.systemNotify({
              title: 'Ha ocurrido un error',
              message: 'Por favor póngase en contacto con el administrador',
              type: 'error'
            });
            // this.routes.navigate(['/system/budget/list']);
          });
        }
      }
      this.zone.run(() => {
        this.getTableData(this.budgetDetailData);
      });
    }, (error) => {
      console.log('error', error);
    });
  }

  selectRow(event) {
    this.orderGroup.source = event.source.data;
    console.log('data', event);
    const indexFind = event.source.data.findIndex((obj) => {
      console.log(obj);
      return obj.id === event.data.id;
    });
    console.log('test', indexFind);
    this.orderGroup.selectedIndex = indexFind;
  }

  moveUp() {
    if (this.orderGroup.selectedIndex !== 0 && this.orderGroup.selectedIndex !== -1) {
      const removed = this.orderGroup.source.splice(this.orderGroup.selectedIndex, 1);
      this.orderGroup.source.splice(this.orderGroup.selectedIndex - 1, 0, removed[0]);

      //console.log(this.orderGroup.source);
      this.dataSourceBudgetDetail = new LocalDataSource(this.orderGroup.source);
      this.budgetDetailData = this.orderGroup.source;
      this.orderGroup.selectedIndex--;
    }
  }
  addGlobal(){
    const dialogRefDisc = this.dialog.open(CreateGlobalDiscountComponent, {
      
    });

    dialogRefDisc.afterClosed().subscribe(result => {
      
      if (result.type == 1){
       this.globalTypo = 1;
        this.budgetHeaderData.discount_global =  Number(result.value);
      }else  if (result.type == 2){
        this.budgetHeaderData.discount_global = result.value
        this.globalTypo = 2;
      }
          
      this.getTableData(this.budgetDetailData)      
        
      });
    
  }

  moveDown() {
    if (this.orderGroup.selectedIndex !== this.orderGroup.source.length - 1) {
      const removed = this.orderGroup.source.splice(this.orderGroup.selectedIndex, 1);
      this.orderGroup.source.splice(this.orderGroup.selectedIndex + 1, 0, removed[0]);

      //console.log(this.orderGroup.source);
      this.dataSourceBudgetDetail = new LocalDataSource(this.orderGroup.source);
      this.budgetDetailData = this.orderGroup.source;
      this.orderGroup.selectedIndex++;
    }
  }
}

export interface IBudgetHeader {
  id?: number;
  external_code?: number;
  work_order_id?: number;
  tenant?: string;
  state?: number;
  legal_text?: string;
  created_date?: Date;
  updated_date?: Date;
  created_user?: number;
  updated_user?: number;
  client_name?: string;
  client_comision?: number;
  client_id?: number;
  client_address?: string;
  client_doc_num?: string;
  client_doc_type?: string;
  client_email?: string;
  client_code?: string;
  currency?: number;
  currency_money?: string;
  tax?: number;
  user_name?: string;
  discount_global? : number
  facturado? : number
}

export interface IBudgetDetail {
  id?: number;
  id_budget_header?: number;
  description?: string;
  provider_id?: number;
  cost_provider?: number;
  quantity?:number;
  unit_price?: number;
  price?: number;
  with_commission?: boolean;
  historic_commission?: number;
  created_user?: number;
  updated_user?: number;
  created_date?: Date;
  updated_date?: Date;
  action_backend?: string;
  create_uuid?: string;
  currency?: number;
  client_comision?: number;
  provider_name?: string;
  price_total?: number;
  invoiced?: number;
  type?: number;
  discount_type?: number;
  discount_amount?: number;
  price_full?: number;
}



// WEBPACK FOOTER //
// ./src/app/system/budget/new-budget/new-budget.component.ts